<template>
    <div>
        <div style="width: 100%">
            <!-- <div class="bubble" :style="'left: calc(' + (props.value === 0 ? 0 : (props.value - 1200) / 800 * 100) + '% - 2.915vmin);top: 8px;'"> -->
            <div :class="newclass" :style="'left: calc(' + (props.value === 0 ? 0 : ((props.value - 1200) / 800) * 100) + '% - 4.58vmin);'">
                <div>
                    {{ props.value }}
                </div>
            </div>
            <!-- <div style="width:3.2vmin;height: 3.2vmin;background-color: #8E43F0; border-radius: 50%; left: 10%;">
                  </div> -->
        </div>
        <div style="width: 100%; display: inline-flex; font-size: 1.2vw">
            <div v-for="index in 4" :style="'width: calc( 100% / 16 ); height:' + props.height + 'vmin ; background-color: #0078A7; border: 1px solid white;'"></div>
            <div v-for="index in 4" :style="'width: calc( 100% / 16 ); height:' + props.height + 'vmin ; background-color: #393D7C; border: 1px solid white;'"></div>
            <div v-for="index in 4" :style="'width: calc( 100% / 16 ); height:' + props.height + 'vmin ; background-color: #A83089; border: 1px solid white;'"></div>
            <div v-for="index in 4" :style="'width: calc( 100% / 16 ); height:' + props.height + 'vmin ; background-color: #A82C31; border: 1px solid white;'"></div>
        </div>
        <div style="width: 100%; display: flex; justify-content: space-between; font-size: 1.1vw">
            <div>1,200</div>
            <div>2,000</div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, defineProps, ref } from 'vue';

const newclass = ref(null);

// const chartdiv = ref(null);
const props = defineProps({
    value: {
        default: 0,
    },
    height: {
        default: 3.33, // props.height 1에서 2로 변경(2023.05.12)
    },
});

const renderBubble = () => {
    if (props.value > 1800) {
        newclass.value = 'bubble kread_fourth';
    } else if (props.value > 1600) {
        newclass.value = 'bubble kread_third';
    } else if (props.value > 1400) {
        newclass.value = 'bubble kread_second';
    } else {
        newclass.value = 'bubble kread_first';
    }
};

onMounted(() => {
    renderBubble();
});
</script>

<style scoped lang="scss">
.bubble {
    width: 9.16vmin;
    height: 6.33vmin; // 5.83에서 수정 (2023.05.12)
    position: relative;
    background-size: contain;
    background-repeat: no-repeat;
    background-position-x: center;
    font-weight: 700;
    font-size: 2vmin;
    text-align: center;
    padding-top: 1.2vmin; // 0.9에서 수정 (2023.05.12)
    color: white;

    &.kread_first {
        background-image: url('@/assets/images/icon/kread_bullet1399.svg');
    }

    &.kread_second {
        background-image: url('@/assets/images/icon/kread_bullet1599.svg');
    }

    &.kread_third {
        background-image: url('@/assets/images/icon/kread_bullet1799.svg');
    }

    &.kread_fourth {
        background-image: url('@/assets/images/icon/kread_bullet1999.svg');
    }
}

@media print {
    .bubble {
        font-size: 1.5vmin;
    }
}

.rounded-borders {
    border-radius: 60px;
}
</style>
